<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import General from '@/services/General';
import Customers from '@/services/Customers';
import Swal from "sweetalert2";
import modalAddApplicationImage from "../../../components/modals/app/modalAddApplicationImage.vue";
import modalUpdateApplicationImage from "../../../components/modals/app/modalUpdateApplicationImage.vue";

import {tableData} from "../tables/dataAdvancedtable";
import { ref } from "vue";

export default {
    components: { Layout, PageHeader, modalAddApplicationImage, modalUpdateApplicationImage },
    page: {
        title: "Manage Application Media",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Manage Application Media",
            items: [
                {
                    text: "Application",
                    href: "/app",
                },
                {
                    text: "Manage Application Media",
                    active: true,
                },
            ],
            isBusy: false,
            error: null,
            showModal: false,
            modalData: [],
            tableData: [],
            showSectionData: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "date_from",
            sortDesc: true,
            fields: [
                {
                    key: "position",
                    label: "Position",
                    sortable: false,
                },
                {
                    key: "image_url",
                    label: "Image",
                    sortable: false,
                },
                {
                    key: "active",
                    label: "Active",
                    sortable: true,
                },
             
                "actions",
            ],
        };
    },
    async created() {
        await this.getApplicationMedia()
    },
    methods: {
        modalAddAppliationMedia() {
            this.$bvModal.show("add_application_media_image")
        },
   
        modalUpdateApplicationImage(item) {
            this.$bvModal.show("update_application_media_image")
            this.modalData = item
        },
   
      
        async getApplicationMedia() {
            try {
                this.toggleBusy();
                const response = await General.getApplicationMedia()
                this.tableData = response.data.data;
                this.totalRows = this.tableData.length;
                this.toggleBusy();
            } catch (error) {
                this.toggleBusy();
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = []
                this.totalRows = 0;
            }
        },
   
        async changeMediaImageStatus(item){
            this.$set(item, 'loading', true);
            try{
                this.statusChangeLoader = true;
                const formData = new FormData();
                formData.append('active',item.active);
                // formData.append('_method','PATCH');
                const response = await General.updateApplicationMedia(item.id,formData)
                if(response.status == 200){
                    Swal.fire("Update Image Status", "Image status updated successfully!", "success");
                }else{
                    Swal.fire("Fail!", 'Something went wrong', "warning");
                }

                this.$set(item, 'loading', false);
            }catch(error){
                this.error = error.response.data.error ? error.response.data.error : "Status Change Failed";
                this.failedmsg(this.error);
                this.$set(item, 'loading', false);

            }finally{
                this.$set(item, 'loading', false);
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        deleteImage(id) {
            Swal.fire({
                title: "Delete Application Image?",
                text: "This Application Image be deleted!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Remove!",
            }).then((result) => {
                if (result.value) {
                    General.deleteApplicationMedia(id)
                        .then((response) => {
                            const res = response.data ? response.data : false;
                            const error = response.data.error ? response.data.error : 'Failed';
                            if (res) {
                                this.getApplicationMedia()
                                Swal.fire("Remove Application Image", "Application Image successfully removed!", "success");
                            } else {
                                Swal.fire("Fail!", error, "warning");
                            }
                        })
                        .catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "Delete Failed";
                            this.failedmsg(this.error)
                        })
                }
            });
        },

        refreshData() {
            this.getApplicationMedia()
        },
 

    },

    middleware: "authentication",
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6 mb-5">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center me-5">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm"
                                            :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                    <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                                        @click="modalAddAppliationMedia()">
                                        <i class="mdi mdi-plus me-2"></i>
                                        Add New Application Media
                                    </a>
                                </div>

                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input v-model="filter" type="search" placeholder="Search..."
                                            class="form-control form-control-sm ms-2"></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="row">
                            <div class="col-sm-12">

                                <div class="table-responsive mb-0">
                                    <b-table :busy="isBusy" :items="tableData" :fields="fields" responsive="sm"
                                        :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn"
                                        show-empty empty-text="No Data Found" @filtered="onFiltered">

                                        <template v-slot:cell(image_url)="data">
                                            <div class="flex-shrink-0">
                                                <a title="Preview Image" :href="data.item.image_url" target="_blank">
                                                    <img class="img-fluid table-images"  :src="data.item.image_url ? `${data.item.image_url}?ts=${Date.now()}` : require('@/assets/images/image_not_found.png')" >
                                                </a>
                                            </div>
                                        </template>
                                        <template v-slot:cell(active)="data">
                                            <div class="d-flex align-items-center">
                                            <b-form-checkbox-group>
                                                <div class="form-check form-switch form-switch-lg mb-3 gap-2">
                                                    <input v-model="data.item.active"
                                                        type="checkbox"
                                                        class="form-check-input"
                                                        id="mediaStatus"
                                                        true-value="1"
                                                        false-value="0"
                                                        @change="changeMediaImageStatus(data.item)"
                                                    />
                                                </div>
                                            </b-form-checkbox-group> 
                                            <b-spinner v-if="data.item.loading" class="align-middle text-primary mb-3" small></b-spinner>
                                            </div>
                                          
                                        </template>
                                        <template v-slot:cell(actions)="data">
                                            <ul class="list-inline mb-0">
                                       
                                                <li class="list-inline-item">
                                                    <a href="javascript:void(0);" class="px-2 text-primary"
                                                        title="Update Image"
                                                        @click="modalUpdateApplicationImage(data.item)">
                                                        <i class="uil uil-pen font-size-18"></i>
                                                    </a>
                                                </li>
                                        
                                                <li class="list-inline-item">
                                                    <a href="javascript:void(0);" class="px-2 text-danger"
                                                        title="Delete Image"
                                                        @click="deleteImage(data.item.id)">
                                                        <i class="uil uil-trash-alt font-size-18"></i>
                                                    </a>
                                                </li>
                                             
                                            </ul>
                                        </template>

                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>

                                    </b-table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalRows"
                                            :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- MODALS -->
         <modalAddApplicationImage @onRefresh="refreshData()" :positions="modalData"></modalAddApplicationImage>
        <modalUpdateApplicationImage @onRefresh="refreshData()" :imageData="modalData"></modalUpdateApplicationImage>
        <!-- /MODALS -->

    </Layout>
</template>
